import {useEffect} from 'react'
import {Outlet, useLocation} from 'react-router-dom'
import {ToastContainer} from 'react-toastify'
import 'react-toastify/dist/ReactToastify.css' 

import {HeaderWrapper} from './components/header'
import {ScrollTop} from './components/scroll-top'
import {Phone} from './components/phone'
import {Content} from './components/content'
import {FooterWrapper} from './components/footer'
import {Sidebar} from './components/sidebar'
// import {ActivityDrawer, DrawerMessenger, InviteUsers} from '../partials'
import {PageDataProvider} from './core'
import {reInitMenu} from '../helpers'
import {ToolbarWrapper} from './components/toolbar'
import {ThemeModeProvider} from '../partials/layout/theme-mode/ThemeModeProvider'
import {NavbarSoftphone} from './components/header/NavbarSoftphone'
import {AgentControls} from './components/header/AgentControls'
import {MobileAgentBar} from './components/header/MobileAgentBar'

import '../../app/modules/shared/styles/theme-overrides.css'

import {useAgentContext} from '../../app/modules/apps/call/AgentContext'

const MasterLayout = () => {
  const location = useLocation()
  const { isAux, handleAuxAction, auxReasonName } = useAgentContext()

  useEffect(() => {
    reInitMenu()
  }, [location.key])

  return (
    <PageDataProvider>
      <ThemeModeProvider>
        <Phone>
          <style>{`
            .global-aux-overlay {
              position: fixed;
              top: 0; left: 0; right: 0; bottom: 0;
              background: rgba(255, 255, 255, 0.7);
              backdrop-filter: blur(8px);
              -webkit-backdrop-filter: blur(8px);
              z-index: 10000;
              display: flex;
              flex-direction: column;
              align-items: center;
              justify-content: center;
            }
            .pause-icon-animated {
              animation: pulsePause 3s infinite ease-in-out;
              filter: drop-shadow(0 0 20px rgba(255, 193, 7, 0.4));
            }
            @keyframes pulsePause {
              0% { transform: scale(1); opacity: 0.8; }
              50% { transform: scale(1.08); opacity: 1; }
              100% { transform: scale(1); opacity: 0.8; }
            }
            .pause-bar {
              transform-origin: center;
            }
            .pause-bar-1 {
              animation: barBreathe 1.2s infinite ease-in-out alternate;
            }
            .pause-bar-2 {
              animation: barBreathe 1.2s infinite ease-in-out alternate-reverse;
              animation-delay: 0.3s;
            }
            @keyframes barBreathe {
              0% { transform: scaleY(0.6); opacity: 0.5; }
              100% { transform: scaleY(1.1); opacity: 1; }
            }
            html[data-bs-theme="dark"] .global-aux-overlay {
              background: rgba(30, 30, 45, 0.8);
            }
            html[data-bs-theme="dark"] .global-aux-overlay h3 {
              color: #f5f8fa !important;
            }
          `}</style>
          
          {isAux && (
            <div className="global-aux-overlay">
              <div className="bg-warning bg-opacity-10 p-6 rounded-circle pause-icon-animated mb-6 border border-warning border-opacity-25">
                <svg width="64" height="64" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1" strokeLinecap="round" strokeLinejoin="round" className="text-warning">
                  <rect x="5" y="4" width="4" height="16" rx="2" className="pause-bar pause-bar-1" fill="currentColor"></rect>
                  <rect x="15" y="4" width="4" height="16" rx="2" className="pause-bar pause-bar-2" fill="currentColor"></rect>
                </svg>
              </div>
              <h3 className="text-gray-800 fw-boldest fs-1 tracking-tight mb-2">System Paused</h3>
              <p className="text-gray-600 fs-4 mb-8 text-center px-4">Your workspace is locked while on break.<br/><span className="fs-6 fw-bold">Current Status: {auxReasonName || 'Break'}</span></p>
              
              <button 
                className="btn btn-warning text-white px-8 py-3 fw-boldest shadow-sm hover-elevate-up rounded-pill fs-5 animate__animated animate__fadeInUp animate__delay-1s"
                onClick={() => handleAuxAction && handleAuxAction(null)}
              >
                RESUME WORK
              </button>
            </div>
          )}

          <div className='d-flex flex-column flex-root app-root' id='sc_app_root'>
            <div className='app-page flex-column flex-column-fluid' id='sc_app_page'>
              <HeaderWrapper />
              <div className='app-wrapper flex-column flex-row-fluid' id='sc_app_wrapper'>
                <Sidebar />
                <div className='app-main flex-column flex-row-fluid' id='sc_app_main'>
                  <div className='d-flex flex-column flex-column-fluid'>
                    <ToolbarWrapper />
                    <Content>
                      <Outlet />
                    </Content>
                  </div>
                  <FooterWrapper />
                </div>
              </div>
            </div>
          </div>
          <ScrollTop />
          
          {/* Mobile & Tablet 1-Row Sticky Dock & Full-Width Burger Menu */}
          <MobileAgentBar />
        </Phone>
      </ThemeModeProvider>
    </PageDataProvider>
  )
}

export {MasterLayout}